// Module
var code = `<div class="trio-color" style="{{>visibility}}">
    {{#.trioColor}}
    <terceraButtonColorPicker coloringButtonColor="{{.Color1}}" enabled="{{~/enabled}}" BackText="{{.ColorText1}}" />
    <terceraButtonColorPicker coloringButtonColor="{{.Color2}}" enabled="{{~/enabled}}" BackText="{{.ColorText2}}" />
    <terceraButtonColorPicker coloringButtonColor="{{.Color3}}" enabled="{{~/enabled}}" BackText="{{.ColorText3}}" />
    {{/}}
</div>`;
// Exports
export default code;